import { IInitialState } from "./types";

export const initialState: IInitialState = {
  registerUserAsAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  changeDistanceAsAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  postApplications: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsPwd: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsMoney: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsInsurance: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsInsurancePromocode: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsInsurancePwd: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsChangeDistance: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsMarathonMark: {
    data: null,
    loading: false,
    error: null,
  },
  postApplicationsMarathonUnmark: {
    data: null,
    loading: false,
    error: null,
  },
  getApplicationsById: {
    params: {
      applicationId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  deleteApplicationById: {
    params: {
      applicationId: null,
    },
    response: {
      data: false,
      loading: false,
      error: null,
    },
  },
  getApplicationsMarathonIndividualIssuance: {
    params: {
      marathonId: null,
      startKitIssuanceType: null,
      paymentMethod: null,
      startKitEnum: null,
      corporateClientId: null,
      country: null,
      status: null,
      searchTerm: null,
      distanceAgeId: null,
      gender: null,
      isPwd: null,
      page: 1,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getApplicationsMarathonCorporateIssuance: {
    params: {
      marathonId: null,
      corporateClientId: null,
      startKitIssuanceType: null,
      paymentMethod: null,
      startKitEnum: null,
      country: null,
      status: null,
      searchTerm: null,
      distanceAgeId: null,
      distanceId: null,
      gender: null,
      isPwd: null,
      page: 1,
      pageSize: 10,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getApplicationsMarathonsExcel: {
    params: {
      startKitIssuanceType: null,
      paymentMethod: null,
      startKitEnum: null,
      corporateClientId: null,
      country: null,
      status: null,
      searchTerm: null,
      distanceAgeId: null,
      distanceId: null,
      gender: null,
      isPwd: null,
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getMyApplications: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  getApplicationsMarathonPublic: {
    params: {
      marathonId: null,
      page: 1,
      pageSize: 10,
      orderBy: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  putApplicationsMarathonExcel: {
    data: null,
    loading: false,
    error: null,
  },
};
